/*
Controller: Families

Operations:
  getFamilies
  getFamiliesByFoundries
  getDeReleasedFamilies
  reReleaseFamilies
  getFamilyGroupByFamilyId
  getFamiliesWithoutSubmission
  getAllDetails
  getFamilyDetails
*/
var Api = require('../config')
var ReReleaseFamiliesRequestDef = require('../definitions/ReReleaseFamiliesRequest')
var FamilyIdsDef = require('../definitions/FamilyIds')

var Families = (function () {
  /*
  Operation: getFamilies
  Query existing families
  Parameters:
    name: Family name
    id: MFP Id of the foundry
  Responses:
    HTTP 200: List of families
    HTTP 504: The request could not be fulfilled because a required service wasn&#39;t available
  */
  function getFamiliesFamilies (name, id) {
    return new Promise(function (resolve, reject) {
      try {
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters['name'] = name
      parameters['id'] = id
      var path = '/families'
      Api
        .request({
          url: path,
          method: 'get',
          headers: {
            'content-type': 'application/json'
          },
          params: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: getFamiliesByFoundries
  Get Families By Foundries
  Parameters:
    foundryIds: Foundry ids with multiple ids separated by comma
    page: page number, starting with 1
    perPage: number of items per page, max 50
    search: search string
    includeCount: should response include total count
  Responses:
    HTTP 200: List of families
    HTTP 504: The request could not be fulfilled because a required service wasn&#39;t available
  */
  function getFamiliesByFoundriesFamilies (foundryIds, page, perPage, search, includeCount) {
    return new Promise(function (resolve, reject) {
      try {
        if (!foundryIds) {
          throw new Error('foundryIds: Missing parameter')
        }
        if (foundryIds && !(typeof foundryIds === 'string')) {
          throw new Error('foundryIds: Wrong type: Got "' + (typeof foundryIds) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters['foundryIds'] = foundryIds
      parameters['page'] = page
      parameters['perPage'] = perPage
      parameters['search'] = search
      parameters['includeCount'] = includeCount
      var path = '/families/families-by-foundries'
      Api
        .request({
          url: path,
          method: 'get',
          headers: {
            'content-type': 'application/json'
          },
          params: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: getDeReleasedFamilies
  Get De-Released Families By Foundry
  Parameters:
    foundryId: MFP Foundry ID
  Responses:
    HTTP 200: List of de-released families
    HTTP 400: Invalid foundry ID
    HTTP 404: Foundry not found
    HTTP 504: PIM service unavailable
  */
  function getDeReleasedFamiliesFamilies (foundryId) {
    return new Promise(function (resolve, reject) {
      try {
        if (!foundryId) {
          throw new Error('foundryId: Missing parameter')
        }
        if (foundryId && !(typeof foundryId === 'string')) {
          throw new Error('foundryId: Wrong type: Got "' + (typeof foundryId) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      var path = '/families/de-released/{foundryId}'
      path = path.replace('{' + 'foundryId' + '}', foundryId)
      Api
        .request({
          url: path,
          method: 'get',
          headers: {
            'content-type': 'application/json'
          },
          params: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: reReleaseFamilies
  Submit Re-Release Families
  Parameters:

  Responses:
    HTTP 200: Re-release submit accepted
    HTTP 400: Invalid request or families not eligible for re-release
    HTTP 403: Operation not permitted
    HTTP 404: Foundry not found
  */
  function reReleaseFamiliesFamilies (bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        ReReleaseFamiliesRequestDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/families/re-release'
      Api
        .request({
          url: path,
          method: 'post',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: getFamilyGroupByFamilyId
  Get related families
  Parameters:
    familyId: Id of the family to extract related families of
    submissionId: Submission Id of the family being modified
  Responses:
    HTTP 200: Family group found
    HTTP 403: Operation not permitted
    HTTP 404: Family group not found
  */
  function getFamilyGroupByFamilyIdFamilies (familyId, submissionId) {
    return new Promise(function (resolve, reject) {
      try {
        if (!familyId) {
          throw new Error('familyId: Missing parameter')
        }
        if (familyId && !(typeof familyId === 'string')) {
          throw new Error('familyId: Wrong type: Got "' + (typeof familyId) + '", but expected: "string"')
        }
        if (!submissionId) {
          throw new Error('submissionId: Missing parameter')
        }
        if (submissionId && !(typeof submissionId === 'string')) {
          throw new Error('submissionId: Wrong type: Got "' + (typeof submissionId) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      var path = '/families/{familyId}/relatedfamilies/{submissionId}'
      path = path.replace('{' + 'familyId' + '}', familyId)
      path = path.replace('{' + 'submissionId' + '}', submissionId)
      Api
        .request({
          url: path,
          method: 'get',
          headers: {
            'content-type': 'application/json'
          },
          params: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: getFamiliesWithoutSubmission
  Query existing families
  Parameters:
    name: Family name
    page: page number, starting with 1
    perPage: number of items per page, max 50
    uniqueName: unique name
    id: MFP Id of the foundry
    submissionId: Submission Id of the family being modified
  Responses:
    HTTP 200: List of families
    HTTP 504: The request could not be fulfilled because a required service wasn&#39;t available
  */
  function getFamiliesWithoutSubmissionFamilies (name, page, perPage, uniqueName, id, submissionId) {
    return new Promise(function (resolve, reject) {
      try {
        if (!submissionId) {
          throw new Error('submissionId: Missing parameter')
        }
        if (submissionId && !(typeof submissionId === 'string')) {
          throw new Error('submissionId: Wrong type: Got "' + (typeof submissionId) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters['name'] = name
      parameters['page'] = page
      parameters['perPage'] = perPage
      parameters['uniqueName'] = uniqueName
      parameters['id'] = id
      var path = '/families/{submissionId}'
      path = path.replace('{' + 'submissionId' + '}', submissionId)
      Api
        .request({
          url: path,
          method: 'get',
          headers: {
            'content-type': 'application/json'
          },
          params: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: getAllDetails
  Get All Skus of Families
  Parameters:
    bodyRequest: Family Ids
  Responses:
    HTTP 200: List of families
    HTTP 504: The request could not be fulfilled because a required service wasn&#39;t available
  */
  function getAllDetailsFamilies (bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        FamilyIdsDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/familiesDetails'
      Api
        .request({
          url: path,
          method: 'post',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: getFamilyDetails
  Get Family Details by Family Id
  Parameters:
    familyId: Id of the family
  Responses:
    HTTP 200: Family details found
    HTTP 403: Operation not permitted
    HTTP 404: Family not found
  */
  function getFamilyDetailsFamilies (familyId) {
    return new Promise(function (resolve, reject) {
      try {
        if (!familyId) {
          throw new Error('familyId: Missing parameter')
        }
        if (familyId && !(typeof familyId === 'string')) {
          throw new Error('familyId: Wrong type: Got "' + (typeof familyId) + '", but expected: "string"')
        }
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      var path = '/familyDetails/{familyId}'
      path = path.replace('{' + 'familyId' + '}', familyId)
      Api
        .request({
          url: path,
          method: 'get',
          headers: {
            'content-type': 'application/json'
          },
          params: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  var ret = {}
  ret['getFamilies'] = getFamiliesFamilies
  ret['getFamiliesByFoundries'] = getFamiliesByFoundriesFamilies
  ret['getDeReleasedFamilies'] = getDeReleasedFamiliesFamilies
  ret['reReleaseFamilies'] = reReleaseFamiliesFamilies
  ret['getFamilyGroupByFamilyId'] = getFamilyGroupByFamilyIdFamilies
  ret['getFamiliesWithoutSubmission'] = getFamiliesWithoutSubmissionFamilies
  ret['getAllDetails'] = getAllDetailsFamilies
  ret['getFamilyDetails'] = getFamilyDetailsFamilies
  return ret
})()

module.exports = Families
